import { useIsDesktop } from '../hooks/useIsDesktop';
import { useIsMobile } from '../hooks/useIsMobile';
import { useMediaQuery } from '../hooks/useMediaQuery';

/**
 * Children to the Mobile-component will only be visible when browsing with a window width lesser
 * than 767px
 */
export function Mobile({children}) {
    return useIsMobile() ? children : null;
}

/**
 * Children to the Desktop-component will only be visible when browsing with a window width
 * greater than or equal to 767px
 */
export function Desktop({children}) {
    return useIsDesktop() ? children : null;
}

export function Responsive({min, max, children}) {
    if (!min && !max) {
        return null;
    }

    const matches = useMediaQuery(
        min ? `(min-width: ${min}px)`
            : max
                ? `(max-width: ${max}px)`
                : null,
    );

    return matches ? children : null;
}
